import type { AccountantStatusWorkHistoryEntity } from "../entities/AccountantStatusEntity";
import type { AccountantStatusRepository } from "../repositories/AccountantStatusRepository";

export class GetAccountantStatusWorkHistoryUseCase {
  constructor(private readonly repository: AccountantStatusRepository) {}

  async execute(): Promise<AccountantStatusWorkHistoryEntity[]> {
    return this.repository.getWorkHistory();
  }
}
